// extracted by mini-css-extract-plugin
export var actions = "_15-0";
export var actionsContainer = "_15-6";
export var border = "_15-1";
export var childFullHeight = "_15-d";
export var collapse = "_15-2";
export var content = "_15-8";
export var contentChild = "_15-c";
export var fullscreen = "_15-a";
export var hasLeftRadius = "_15-i";
export var headerContainer = "_15-3";
export var headerRow = "_15-5";
export var hidePadding = "_15-9";
export var navCollapsedGap = "_15-j";
export var noScrollX = "_15-k";
export var noScrollY = "_15-l";
export var noTopPadding = "_15-g";
export var optOutTopPadding = "_15-b";
export var pageMain = "_15-h";
export var pageOuter = "_15-e";
export var pagePadding = "_15-7";
export var profile = "_15-m";
export var profileContainer = "_15-n";
export var profileImage = "_15-o";
export var profileMain = "_15-p";
export var profileSubtitle = "_15-r";
export var profileTitle = "_15-q";
export var showLeftPadding = "_15-f";
export var tabsWrapper = "_15-4";
export var title = "_15-s";